export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-695b69e5fe4e2bdd4332019736a99545.svg";